import { render, staticRenderFns } from "./WidgetBookingCa.vue?vue&type=template&id=bff1df04&scoped=true"
import script from "./WidgetBookingCa.vue?vue&type=script&lang=js"
export * from "./WidgetBookingCa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff1df04",
  null
  
)

export default component.exports